export default {"src":"/pro/_next/static/media/vlp-square-icon.3aeb3415.svg","height":268,"width":268,"blurWidth":0,"blurHeight":0};